import request from '@/plugin/axios'
import { sysPath } from '@api/sys.common'

export function AccountLogin (params) {
  
  return request({
    url: sysPath + '/hx-mart/api/v1/sys/login',
    method: 'post',
    data: params
  })

}
